/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Modal,
  Heading,
  SvgIcon,
  Button,
  Spinner,
  CenteredContainerDisplay
} from '../'

const UPLOADING = 0
const SUCCESS = 1
const FAIL = 2

export class FileUploadProgressModal extends React.Component {
  static propTypes = {
    uploadSuccess: PropTypes.bool,
    onUploadSuccessClick: PropTypes.func,
    onUploadFailClick: PropTypes.func,
    uploadingText: PropTypes.string,
    failText: PropTypes.string,
    successText: PropTypes.string
  }

  static defaultProps = {
    uploadingText:  "Uploading",
    failText:  "File upload failed.",
    successText: "File upload complete."
  }

  constructor(props) {
    super(props)

    this.state = {
      progress: UPLOADING
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.uploadSuccess !== null) {
      this.setState({ progress: nextProps.uploadSuccess ? SUCCESS : FAIL })
    }
  }

  render() {
    let modalProps = {}

    switch(this.state.progress) {
      case UPLOADING:
        modalProps.body =
          <CenteredContainerDisplay
            yAdjustPercentage={-5}
            content={
              <Spinner type="track">
                {this.props.uploadingText}
              </Spinner>
            }
          />
        break

      case SUCCESS:
        modalProps.body =
          <Heading className="slds-text-align_center slds-m-top_medium">
            {this.props.successText}
          </Heading>
        modalProps.footer =
          <Button
            onClick={() => this.props.onUploadSuccessClick
              ? this.props.onUploadSuccessClick()
              : null
            }
            className="slds-align_absolute-center">
            OK
          </Button>
        break

      case FAIL:
        modalProps.body =
          <React.Fragment>
            <div className="slds-align_absolute-center slds-m-bottom_medium">
              <SvgIcon
                variant="utility"
                symbol="warning"
                colour="error"
                size="medium"
              />
            </div>
            <Heading className="slds-align_absolute-center">
              {this.props.failText}
            </Heading>
          </React.Fragment>
        modalProps.footer =
          <Button
            onClick={() => this.props.onUploadFailClick
              ? this.props.onUploadFailClick()
              : null
            }
            className="slds-align_absolute-center">
            OK
          </Button>
        break

      default:
        break
    }

    return (
      <Modal
        {...modalProps}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/file-upload-progress-modal/index.js